export const getImageUrl = (path) => {
  // eslint-disable-next-line no-undef
  if (!path) return '';

  const base = process.env.REACT_APP_IMAGE_BASE_URL + '/uploads';
  const separator = path.includes('?') ? '&' : '?';
  const randomNumber = Math.floor(Math.random() * 1000000);

  return `${base}${path}${separator}r=${randomNumber}`;
};
